import React from 'react';
import { includedTools } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function IncludedTools() {
  return <section className="w-full bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-227" data-mp="94q3vi8xmtbc">
      <div className="mx-auto max-w-5xl" data-id="element-228" data-mp="55ha4ddw6vfs">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-229" data-mp="52biorhsjhgw">
          Included with your access
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-230" data-mp="wukfjwhimbu0">
          40+ clinical workflow tools built to be used chairside, not stored in a folder.
        </p>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-231" data-mp="ntupzaiulhoq">
          {includedTools.map(tool => <article key={tool.title} className="flex flex-col rounded-2xl border border-navy-100 bg-white p-5" data-id="element-232" data-mp="ivayyvpedfpi">
              <span className="text-2xl" aria-hidden="true" data-id="element-233" data-mp="33lijevynks2s">
                {tool.emoji}
              </span>
              <h3 className="mt-3 text-[13px] font-extrabold uppercase tracking-[0.08em] text-navy-700" data-id="element-234" data-mp="3srwbwwqo0bsb">
                {tool.title}
              </h3>
              <p className="mt-auto pt-2.5 text-[14px] leading-relaxed text-ink-soft" data-id="element-235" data-mp="m97iewqp5cb">
                {tool.description}
              </p>
            </article>)}
        </div>

        <SectionCTA transformation="Everything you need to run the same process on every case." label="Get the 40+ workflow tools" subline="$27 one-time · Instant digital access" data-id="element-236" data-mp="3nr8cpnsa8on0" />
      </div>
    </section>;
}